import urlBuilder from "app/umbraco/helpers/urlBuilder";
import getClosestWidthTier from "app/media/helpers/getClosestWidthTier";
import { UmbracoImageCrop, UmbracoImageFocalPoint } from "../models/media.interface";

export default (src: string, clientWidth: number, extensionType?: string, crop?: UmbracoImageCrop, focalPoint?: UmbracoImageFocalPoint, heightRatio?: number): string => {
    const imageUrl = urlBuilder(src);
    const params = new URLSearchParams();

    if (crop && crop.coordinates) {
        params.set("crop", `${crop.coordinates.x1},${crop.coordinates.y1},${crop.coordinates.x2},${crop.coordinates.y2}`);
        params.set("cropmode", "percentage");
    }
    else if (focalPoint) {
        params.set("center", `${focalPoint.top},${focalPoint.left}`);
        params.set("mode", "crop");

        if (typeof (heightRatio) !== "undefined") {
            params.set("heightratio", heightRatio.toString());
        }
    }
    else {
        params.set("center", `${0.5},${0.5}`);
        params.set("mode", "crop");

        if (typeof (heightRatio) !== "undefined") {
            params.set("heightratio", heightRatio.toString());
        }
    }

    // Search for closest value to only have 5 different image sizes to cache.
    const imageWidth = getClosestWidthTier(clientWidth);
    params.set("width", imageWidth.toString());

    params.set("upscale", "true");
    params.set("format", extensionType || "webp");

    if (extensionType === "jpg" || extensionType === "jpeg") {
        params.set("bgcolor", "white");
    }
    else if (extensionType === "png" || extensionType === "gif") {
        params.set("bgcolor", "transparent");
    }

    // TODO: .WEBP extension

    const querySeparator = imageUrl.toString().indexOf("?") > 0 ? "&" : "?";
    return `${imageUrl}${querySeparator}${params.toString()}`;
};
